<template>
  <div id="videoplayer_container">
    <VideoDouob v-for="item in playlist" :key="item.id" :ref="item.id" :src="item.video.url"
      @ended="onVideoPlayerEnded" :muted="true" />
  </div>

</template>

<script>
import VideoDouob from '../VideoDouob.vue';

export default {
  components: {
    VideoDouob,
  },
  data() {
    return {
      selected: {},
    }
  },
  props: {
    playlist: {
      type: Array,
      required: true,
      played: false,
    },
  },
  methods: {
    Pause(){
      this.videoplayer.pause()
    },
    ResumePlayback(){
      this.videoplayer.play()
    },
    onVideoPlayerEnded() {
      // Next video
      // const arrToLook = this.standbyMode ? this.options.standByVideos : this.options.videos; // con esto la playlist sigue al proximo video
      let currElementIndex = this.playlist.indexOf(this.selected);
      const nextIndex = (currElementIndex + 1) % this.playlist.length;
      this.selected = null;
      this.selected = this.playlist[nextIndex]
      this.$emit('videoEnded')
    },
  },
  computed: {
    videoplayer() {
      return this.$refs[this.selected.id][0]
    },
  },
  watch: {
    // volume(vol) {
    //   // if (this.player) {
    //   //   this.player.volume = vol / 100;
    //   // }
    // }
    selected(selected, prevVideo) {
      console.log("Selected changed", selected.video.filename)
      // console.log("***", prevVideo.id)
      if (prevVideo.id) {
        this.$refs[prevVideo.id][0].stop()
      }
      this.videoplayer.play()
    }
  },
  mounted() {
    if(this.playlist.length == 0) {
      console.error("No videos in playlist")
      return
    }
    this.selected = this.playlist[0]
    this.$refs
  },
}
</script>
<style lang="scss" scoped>
</style>